// extracted by mini-css-extract-plugin
export var table = "PageStaffDepartment-module--table--2MVtI";